import toast from "react-hot-toast";
import { AxiosError } from "axios";

export type ApiErrorResponse = {
  trigger: string;
  message: string;
};

export type ApiResponse<T> = {
  res: T | null;
  error: AxiosError | null;
};

export async function handleApi<T>(
  promise: Promise<T>,
  showToast: boolean = true
): Promise<ApiResponse<T>> {
  try {
    const res = await promise;
    return { res, error: null };
  } catch (error) {
    const axiosError = error as AxiosError;

    if (axiosError.code === "ERR_CANCELED") {
      console.warn("Request canceled");
      return { res: null, error: null };
    }

    const errorMessage = handleApiErrorMessages(axiosError);
    if (showToast) toast.error(errorMessage);
    return {
      res: null,
      error: error as AxiosError,
    };
  }
}

export const handleApiErrorMessages = (error: AxiosError): string => {
  const defaultMessage = "An unexpected error has occurred";

  const data = error.response?.data;

  if (typeof data === "object" && data !== null) {
    const { message, trigger } = data as ApiErrorResponse;
    return message || trigger || defaultMessage;
  }

  if (typeof data === "string") return data;

  return error.message || defaultMessage;
};
